import { isDev } from './config';

interface LoggerType {
  log: (...args: Parameters<typeof console.log>) => void;
  info: (...args: Parameters<typeof console.info>) => void;
  warn: (...args: Parameters<typeof console.warn>) => void;
  error: (...args: Parameters<typeof console.error>) => void;
}

let Logger: LoggerType;

if (isDev) {
  Logger = {
    log: console.log,
    info: console.info,
    warn: console.warn,
    error: console.error,
  };
} else {
  Logger = {
    log: () => undefined,
    info: () => undefined,
    warn: () => undefined,
    error: () => undefined,
  };
}

export default Logger;
